import React, { Component } from 'react';
import { SimpleLoader } from '@dev/ee-components';
import styled from 'styled-components';

const Layout = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
`;

class PageLoader extends Component<any> {
    public render(): JSX.Element {
        return (
            <Layout>
                <SimpleLoader />
            </Layout>
        );
    }
}

export default PageLoader;
